export const getOfferingText = (numProgams: number) => (numProgams === 1 ? '1 Program' : `${numProgams} Program Bundle`)

export const formatProgramNames = (programNames: string[]) => programNames.join(', ').replace(/, ([^,]*)$/, ' & $1')
